import React from 'react';
import { Tool } from 'models/chatbot';
import { CommandChip, CommandChipsContainer } from './styles';

interface CommandChipsProps {
  tools: Tool[];
  setQuestion: (question: string) => void;
  handleInputChange: (value: string, tools: Tool[]) => void;
  inputRef: React.RefObject<HTMLInputElement>;
  selectCommand: (commandName: string) => string;
}

export const CommandChips: React.FC<CommandChipsProps> = ({
  tools,
  setQuestion,
  handleInputChange,
  inputRef,
  selectCommand,
}) => {
  if (!tools || tools.length === 0) return null;

  return (
    <CommandChipsContainer>
      {tools.map((tool, index) => (
        <CommandChip
          key={index}
          onClick={() => {
            const command = `${tool.function.command}`;
            setQuestion(command);
            selectCommand(tool.function.command.substring(1));

            if (inputRef.current) {
              inputRef.current.focus();
              const commandWithSpace = command + ' ';
              setQuestion(commandWithSpace);
              handleInputChange(commandWithSpace, tools);
            }
          }}
        >
          {tool.function.command}
        </CommandChip>
      ))}
    </CommandChipsContainer>
  );
};
